<template>
  <div class="nt-video" @click="togglePlayPause()" >
    <div v-show="!playing && (!played || !controls) && !this.loaded && !error" class="loader"><div></div><div></div><div></div><div></div></div>
    <div :id="id + '-btn-play'" v-show="!playing && (!played || !controls) && this.loaded" class="button button--play"></div>
    <div :id="id + '-btn-pause'" v-show="playing && !controls" class="button button--pause pause">
      <svg><use xlink:href="#icon-pause"/></svg>
    </div>

    <div v-show="error" class='error'>
      <span class="message">
      {{ displayedErrorMessage }}
      </span>
    </div>

    <div v-show="!played && !error" class='video-background' :style="`background-image: url(` + poster + `)`">
    </div>
    <video
      :id="id"
      class="video"
      ref="video"
      preload="none"
      webkit-playsinline="true" playsinline="true"
      width="100%" height="100%"
      frameborder="0" @error="onError">

      <source :src="videoUrl" type="video/mp4">
      Your browser does not support the video tag.
    </video>
  </div>
</template>

<script>
  export default {
    name: 'NtVideo',
    props: {
      data: {
        type: Object,
        default: null
      },
      videoUrl: {
        type: String,
        default: null
      },
      id: {
        type: String,
        default: 'video'
      },
      autoplay: {
        type: Boolean
      },
      poster: {
        type: String,
        default: '/'
      },
      disableShare: {
        type: Boolean,
        default: false
      },
      controls: {
        type: Boolean,
        default: false
      },
      share: {
        type: Object,
        defult: null
      },
      errorMessage: {
        type: String
      },
      displayedErrorMessage: {
        type: String,
      }
    },
    methods: {
      togglePlayPause() {
        if ((!this.controls || !this.played) && this.loaded) {
          if (this.playing) {
            this.pause()
          } else {
            this.play()
          }
        }
      },
      play() {
        if (!this.playing && !this.error) {
          this.player.play()
          this.playing = true
          this.played = true
        }
      },
      pause() {
        if (this.playing) {
          this.player.pause()
          this.playing = false
        }
      },
      onError() {
        this.error = true
        if (this.errorMessage) {
          console.warn('Error in playing the video:', this.errorMessage)
        }
      },
    },
    data() {
      return {
        player: null,
        displayShareOverlay: false,
        playing: false,
        played: false,
        error: false,
        loaded: false
      }
    },
    created() {
      this.$parent.$on('stop', () => {
        this.pause()
      })
    },
    mounted() {
      if (!this.poster.length || !this.videoUrl.length || this.errorMessage) {
        this.onError()
      }

      this.player = this.$refs.video
      this.errorState = this.player.readyState
      if (this.controls) {
        this.player.setAttribute('controls', 'controls')
      }
      if (this.autoplay) {
        this.player.play()
      }
      this.player.onended = () => {
        this.player.currentTime = 0
        this.playing = false
      }

      this.player.addEventListener('error', this.errorOcurred)
      this.player.addEventListener('abort', this.errorOcurred)
      this.loaded = this.player.readyState
      this.player.addEventListener('canplay', () => {
        this.loaded = true
      })
      if (this.player.readyState > 3) {
        this.loaded = true
      }
      this.player.load()
    }
  }
</script>
